import React from 'react'
import Loading from "../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const MobileEnterprise = dynamic(() => import('../components/enterprise/MobileEnterprise'), {
  loading: () => <Loading />,
});
const DesktopEnterprise = dynamic(() => import('../components/enterprise/DesktopEnterprise'), {
  loading: () => <Loading />,
});

const enterprise = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>Enterprise POS Solutions for Retail, Grocery, Restaurants, and FMCG</title>
        <meta name="description" content="Explore QueueBuster’s Enterprise POS Solutions for retail, grocery, restaurants, and FMCG sectors. A cloud-based POS systems designed to streamline business operations." />
        <link rel="canonical" href="https://queuebuster.co/enterprise-pos-solution" />
        <link rel="alternate" href="https://queuebuster.co/enterprise-pos-solution" hrefLang="en" />
        <meta property="og:title" content="Enterprise POS Solutions for Retail, Grocery, Restaurants & FMCG | QueueBuster POS" />
        <meta property="og:description" content="Unlock the potential of your business with QueueBuster’s enterprise POS solutions. Tailored for retail, grocery, restaurants, and FMCG, our cloud-based system offers seamless billing, inventory control, and customer management to maximize efficiency and growth." />
        <meta property="og:url" content="https://queuebuster.co/hardware-partners/pinelabs-pos-system" />
        <meta
          property="og:image"
          content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/enterprise+(1).jpg"
        />
      </Head>
      <SchemaTags page="enterprise-pos-solution" />
      {
        mobileView ? <MobileEnterprise /> : <DesktopEnterprise />
      }
    </>
  )
}

export default enterprise